import React, { useEffect, useState } from 'react';
import './NewPedidos.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import moneda from '../../moneda';

export default function NewPedidos() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [pago, setPago] = useState('');
    const [next7Days, setNext7Days] = useState([]);
    const [codigo, setCodigo] = useState('');
    const [entrega, setEntrega] = useState('');
    const [total, setTotal] = useState('0.00');
    const [nota, setNota] = useState('');
    const [estado, setEstado] = useState('Pendiente');
    const [address, setAddress] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedProducts, setSelectedProducts] = useState({});
    const [earning, setEarning] = useState(0);

    const [products, setProducts] = useState([]);
    const [companies, setCompanies] = useState([]);

    const [mensaje, setMensaje] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        const dayNames = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
        const today = new Date();
        const next7 = Array.from({ length: 7 }).map((_, i) => {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            const name = dayNames[d.getDay()];
            const dateStr = d.toISOString().split('T')[0];
            return { name, date: dateStr, deliver: false };
        });
        setNext7Days(next7);
    }, []);

    const fetchProducts = () => {
        fetch(`${baseURL}/productosGet.php`)
            .then(res => res.json())
            .then(data => setProducts(data.productos || []))
            .catch(err => console.error(err));
    };

    const fetchCompanies = () => {
        fetch(`${baseURL}/companiesGet.php`)
            .then(res => res.json())
            .then(data => setCompanies(data.companies || []))
            .catch(err => console.error(err));
    };

    useEffect(() => {
        fetchProducts();
        fetchCompanies();
    }, []);

    useEffect(() => {
        const totalEarning = Object.values(selectedProducts).reduce((acc, p) => {
            const days = getSelectedDaysCount(p.weeklyOrder);
            const profit = p.profit || 0;
            const cantidad = parseFloat(p.cantidad) || 0;
            return acc + (profit * cantidad * days);
        }, 0);
        setEarning(totalEarning);
    }, [selectedProducts]);

    

    const obtenerImagen = (item) => item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || '';

    const toggleProductSelection = (prod) => {
        const exists = !!selectedProducts[prod.idProducto];
        if (!exists) {
            // initialize weeklyOrder as copy of next7Days
            let weeklyInit = next7Days.map(d => ({ ...d }));
            weeklyInit = ensureAtLeastOneSelected(weeklyInit);
            setSelectedProducts(prev => ({
                ...prev,
                [prod.idProducto]: {
                    idProducto: prod.idProducto,
                    titulo: prod.titulo,
                    cantidad: 1,
                    item: prod.item ? [prod.item] : [],
                    precio: prod.precio,
                    profit: prod.profit || 0,
                    weeklyOrder: weeklyInit,
                    imagen: obtenerImagen(prod)
                }
            }));
        } else {
            const copy = { ...selectedProducts };
            delete copy[prod.idProducto];
            setSelectedProducts(copy);
        }
    };

    const updateCantidad = (productId, cantidad) => {
        setSelectedProducts(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                cantidad: parseInt(cantidad) || 1
            }
        }));
    };

    const updateItem = (productId, itemValue) => {
        setSelectedProducts(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                item: [itemValue]
            }
        }));
    };

    const toggleWeeklyDay = (productId, date) => {
        setSelectedProducts(prev => {
            const prod = prev[productId];
            if (!prod) return prev;
            let newWeekly = prod.weeklyOrder.map(w => w.date === date ? { ...w, deliver: !w.deliver } : w);
            newWeekly = ensureAtLeastOneSelected(newWeekly);
            return { ...prev, [productId]: { ...prod, weeklyOrder: newWeekly } };
        });
    };

    const getSelectedDaysCount = (weekly) => {
        if (!weekly) return 1;
        let count = 0;
        if (Array.isArray(weekly)) {
            count = weekly.filter(d => d && d.deliver).length;
        }   else if (typeof weekly === 'object') {
            count = Object.values(weekly).filter(Boolean).length;
        }
        return count > 0 ? count : 1;
    };

    // Ensure at least one day in weekly array is selected. Prefer today's date, else first.
    const ensureAtLeastOneSelected = (weekly, preferDate = new Date()) => {
        if (!Array.isArray(weekly) || weekly.length === 0) return weekly;
        const any = weekly.some(d => d && d.deliver === true);
        if (any) return weekly.slice();
        const todayStr = new Date(preferDate).toISOString().split('T')[0];
        const idx = weekly.findIndex(d => d.date === todayStr);
        if (idx >= 0) {
            return weekly.map((d, i) => i === idx ? { ...d, deliver: true } : { ...d });
        }
        // fallback to first
        return weekly.map((d, i) => i === 0 ? { ...d, deliver: true } : { ...d });
    };

    useEffect(() => {
        const total = Object.values(selectedProducts).reduce((sum, prod) => {
            const days = getSelectedDaysCount(prod.weeklyOrder);
            return sum + ((parseFloat(prod.precio) || 0) * (parseFloat(prod.cantidad) || 0) * days);
        }, 0);
        setTotal(total.toFixed(2));
    }, [selectedProducts]);

    const normalizeWeeklyForOrder = (weekly) => {
        if (!weekly) return [];
        if (Array.isArray(weekly)) {
            const w = ensureAtLeastOneSelected(weekly);
            return w.filter(d => d.deliver).map(d => ({ name: d.name, date: d.date, deliver: false }));
        }
        return Object.keys(weekly).filter(k => weekly[k]).map(k => ({ name: k, date: '', deliver: false }));
    };

    const createOrder = async (e) => {
        e.preventDefault();
        if (Object.keys(selectedProducts).length === 0) {
            toast.error('Selecciona al menos un producto');
            return;
        }

        const productosToSend = Object.values(selectedProducts).map(prod => ({
            ...prod,
            weeklyOrder: normalizeWeeklyForOrder(prod.weeklyOrder)
        }));

        const formData = new FormData();
        formData.append('estado', estado);
        formData.append('productos', JSON.stringify(productosToSend));
        formData.append('total', total);
        formData.append('nombre', name);
        formData.append('email', email);
        formData.append('telefono', telefono);
        formData.append('entrega', entrega === 'home' ? address : entrega);
        formData.append('nota', nota);
        formData.append('codigo', codigo);
        formData.append('pago', pago);
        formData.append('selectedCompanyId', selectedCompany);
        formData.append('isCustomCompany', '0');
        formData.append('earning', earning);

        setMensaje('Procesando...');

        try {
            const res = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData
            });
            const data = await res.json();
            if (data.mensaje) {
                setMensaje('');
                toast.success(data.mensaje);
                setModalOpen(false);
                // reset form
                setSelectedProducts({});
                setName(''); setEmail(''); setTelefono(''); setPago(''); setNota(''); setCodigo(''); setTotal('0.00');
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');
        }
    };

    const toggleModal = () => {
        setModalOpen(prev => !prev);
    };

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>+</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Pedido</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id='crearForm' onSubmit={createOrder}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input value={name} placeholder='Nombre' onChange={(e) => setName(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input placeholder='Telefono' value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Compania </legend>
                                    <select value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
                                        <option value="">Selecciona Compania</option>
                                        {companies.map(comp => <option key={comp.idCompany} value={comp.idCompany}>{comp.name}</option>)}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Entrega</legend>
                                    <select value={entrega} onChange={(e) => setEntrega(e.target.value)}>
                                        <option value="">Selecciona opción</option>
                                        <option value="home">Envío a domicilio</option>
                                        <option value="Retiro en personalmente">Retirar personalmente</option>
                                    </select>
                                </fieldset>
                                {entrega === 'home' && (
                                    <fieldset>
                                        <legend>Dirección</legend>
                                        <input value={address} placeholder='Ingresa tu dirección (obligatorio)' onChange={(e) => setAddress(e.target.value)} />
                                    </fieldset>
                                )}
                                <fieldset>
                                    <legend>Pago</legend>
                                    <select value={pago} onChange={(e) => setPago(e.target.value)}>
                                        <option value="">Selecciona opción</option>
                                        <option value="Efectivo">Efectivo</option>
                                        <option value="Transferencia">Transferencia</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input value={codigo} placeholder='Codigo de descuento (opcional)' onChange={(e) => setCodigo(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input value={nota} placeholder='Agrega una nota (opcional)' onChange={(e) => setNota(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select value={estado} onChange={(e) => setEstado(e.target.value)}>
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="Entregado">Entregado</option>
                                        <option value="Rechazado">Rechazado</option>
                                        <option value="Pagado">Pagado</option>
                                        <option value="Recibido">Recibido</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Total </legend>
                                    <input value={total} disabled />
                                </fieldset>
                            </div>

                            <div className='newOrder cardsProductData'>
                                {products.map(prod => {
                                    const isSelected = !!selectedProducts[prod.idProducto];
                                    const items = prod.item ? [prod.item] : [];
                                    return (
                                        <div key={prod.idProducto} className='productCardWrapper'>
                                            <div className='cardProductData'>
                                                <img src={obtenerImagen(prod)} alt="imagen" />
                                                <div className='cardProductDataText'>
                                                    <div className='upperLeft'>
                                                        <h3>{prod.titulo}</h3>
                                                        <strong>{moneda} {prod.precio} {isSelected ? <span>x{selectedProducts[prod.idProducto].cantidad}</span> : ''}</strong>
                                                        <span>{prod.item}</span>
                                                    </div>
                                                    <div className='upperRight'>
                                                        {isSelected && (
                                                            <input
                                                                className='quantityInput'
                                                                type="number"
                                                                min="1"
                                                                value={selectedProducts[prod.idProducto]?.cantidad || 1}
                                                                onChange={(e) => updateCantidad(prod.idProducto, e.target.value)}
                                                            />
                                                        )}
                                                        <input
                                                            className='checkProduct'
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => toggleProductSelection(prod)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {isSelected && (
                                                <div className='belowCardWrapper'>
                                                    <div className='productItems'>
                                                        {items.length > 0 && items.map((item, index) => (
                                                            item && (
                                                                <label key={index} className='checkBoxItem'>
                                                                    <input
                                                                        type="radio"
                                                                        name={`item-${index}-${prod.idProducto}`}
                                                                        value={item}
                                                                        checked={selectedProducts[prod.idProducto].item[0] === item}
                                                                        onChange={() => updateItem(prod.idProducto, item)}
                                                                    />
                                                                    {item}
                                                                </label>
                                                            )
                                                        ))}
                                                    </div>
                                                    <div className='weeklyOrderWrapper'>
                                                        {selectedProducts[prod.idProducto].weeklyOrder && selectedProducts[prod.idProducto].weeklyOrder.map(w => (
                                                            <label key={w.name} className="checkBoxItem">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!w.deliver}
                                                                    onChange={() => toggleWeeklyDay(prod.idProducto, w.date)}
                                                                />
                                                                {w.name} {w.date}
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                            </div>

                            {mensaje ? (
                                <button type='button' className='btnLoading' disabled>{mensaje}</button>
                            ) : (
                                <button type='submit' className='btnPost'>Agregar</button>
                            )}
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}